import {  connectInfiniteHits, connectPagination } from "react-instantsearch-dom";
import { InjectedHits, InjectedInfiniteHits } from "./InjectedHits";
import { isSuperbrandHeroPresent } from "@/redux/actions/headerAction";

import StatsComp from "../StatsComp";
import ProductItemTile from "../ProductItemTile";
import ContentTilePLP from "@/components/BuilderIO/ContentTilePLP";
import { BuilderComponent } from "@builder.io/react";
import { builderClient } from "@/utils/builder";
import { useState, useEffect } from "react";
import styles from "./PaginationComp.module.scss";
import { useRouter } from "next/compat/router";
import { useSelector } from "react-redux";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import PaginationCustom from './CustomPagination'
import { generalConstants } from "@/utils/constants";
import { removeTargetAttr } from "@/helpers/generalHelper";

const CustomPagination = connectPagination(PaginationCustom)

const PaginationComp = (props) => {
  const { handlePageUpdate, builderContentJson1, builderContentJson2 } = props;

  const isTablet= useMediaQuery("(max-width: 1024px) and (min-width: 769px)");
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isTabletOrBelow = isTablet || isMobile ? true : false;
  const router = useRouter();
  const filters = useSelector((state) => state.filters);

  const ContentTilePLP1 = () => {
    if (builderContentJson1) {
      removeTargetAttr();
      return (
        <li
          id="content-tile-plp"
          className={`ais-Hits-item ${styles.content_tile} content-tile-phone content-tile-plp-1`}
        >
          <BuilderComponent
            model="content-tile-plp"
            content={builderContentJson1}
          />
        </li>
      );
    }
  };
  const ContentTilePLP2 = () => {
    if (builderContentJson2) {
      removeTargetAttr();
      return (
        <li
          id="content-tile-plp-2"
          className={`ais-Hits-item ${styles.content_tile} content-tile-phone content-tile-plp-2`}
        >
          <BuilderComponent
            model="content-tile-plp-2"
            content={builderContentJson2}
          />
        </li>
      );
    }
  };

  let prevPosition1 = null;
  let prevPosition2 = null;

  // Slots used to specify what custom component to insert and in which position of the hits
  const mobileSlots = () => [
    {
      // First content tile
      injectAt: ({ position }) => {
        // For mobile and tablet, need to insert content tile after every load more for repeating content tiles as by default it only insert the tile once
        const nextPositionIncrement = generalConstants.algolia_plp_hitcount_mobile; // Since 32 hits are fetched for mobile, after every 32 hits (when load more is clicked), content tile needs to be inserted
        if (
          position === generalConstants.builder_plp_content_tile1_position
        ) {
          prevPosition1 = position;
          return true; // Content tile will be injected at this position if true is returned, else will display regular algolia hit at this position
        }
        return false;
      },
      slotComponent: ContentTilePLP1,
    },
    {
      // Second content tile
      injectAt: ({ position }) => {
        const nextPositionIncrement = generalConstants.algolia_plp_hitcount_mobile;
        if (
          position === generalConstants.builder_plp_content_tile2_position - 2
        ) {
          prevPosition2 = position;
          return true;
        }
        return false;
      },
      slotComponent: ContentTilePLP2,
    },
  ];

  const tabletSlots = () => [
    {
      injectAt: ({ position }) => {
        // For mobile and tablet, need to insert content tile after every load more for repeating content tiles as by default it only insert the tile once
        const nextPositionIncrement = generalConstants.algolia_plp_hitcount_tablet; // Since 44 hits are fetched for tablet, after every 44 hits (when load more is clicked), content tile needs to be inserted
        if (
          position === generalConstants.builder_plp_content_tile1_position
        ) {
          prevPosition1 = position;
          return true;
        }
        return false;
      },
      slotComponent: ContentTilePLP1,
    },
    {
      injectAt: ({ position }) => {
        const nextPositionIncrement = generalConstants.algolia_plp_hitcount_tablet;
        if (
          position === generalConstants.builder_plp_content_tile2_position - 2
        ) {
          prevPosition2 = position;
          return true;
        }
        return false;
      },
      slotComponent: ContentTilePLP2,
    },
  ];
  let currentPage = router.query?.page || 1;

  return (
    <div className="grid-md-12">
      {isTabletOrBelow ? (
        <InjectedInfiniteHits
          slots={isMobile ? mobileSlots : tabletSlots}
          hitComponent={Hits}
          device={isMobile ? "mobile" : "tablet"}
        />
      ) : (
        <InjectedHits
          slots={() => [
            {
              injectAt: currentPage == 1 && generalConstants.builder_plp_content_tile1_position,
              slotComponent: ContentTilePLP1,
            },
            {
              injectAt: currentPage == 1 && generalConstants.builder_plp_content_tile2_position - 1,
              slotComponent: ContentTilePLP2,
            },
          ]}
          hitComponent={Hits}
        />
      )}
      {isTabletOrBelow && <CustomInfiniteHits loadPrevious />}
      {!isTabletOrBelow && <CustomPagination router={router} defaultRefinement={+router?.query?.page || 1} handlePageUpdate={handlePageUpdate} />}
    </div>
  );
};

const InfiniteHitLoadMore = ({ hits, hasMore, refineNext }) => (
  <div>
    {hasMore && 
    <button
      className={`hit-loadMore-btn ${!hasMore ? "loading" : ""} ${isSuperbrandHeroPresent?"mb-0":""}`}
      onClick={ () => {
        refineNext();
        // router.push({pathName:router.asPath, query: {...router.query ,'page': `${(hits.length / 18) }`}}, undefined, { scroll: false })
      }}
      disabled={!hasMore}
    >
      <span className="loadmore-txt x-small-xs">Load More</span>
      <div className="loadmore-result">
        <span className="hits-length xxx-small-xs">{hits.length}/</span>
        <span>
          <StatsComp type="load-more" />
        </span>
      </div>
    </button>
  }
  </div>
);
const CustomInfiniteHits = connectInfiniteHits(InfiniteHitLoadMore);

const Hits = ({ hit, key, index , isMobile }) => {
  return (
    <li
      key={hit.objectID}
      id={`product-item-1-${hit.id}`}
      className="ais-Hits-item"
    >
      <ProductItemTile hit={hit} itemkey={index + 1} isMobile={isMobile}/>
    </li>
  );
};

export default PaginationComp;
